import TileType from "./TileType";
import { TileTypeRarity } from "./TileTypeRarity";

export const SpecialTileTypes = {
    /**
     * @constant
     * @type {TileType}
     */
    EMPTY: new TileType('0', 'Empty', 'sky.png', true, false, TileTypeRarity.COMMON),
    /**
     * @constant
     * @type {TileType}
     */
    SKY: new TileType('1', 'Sky', 'sky.png', true, false, TileTypeRarity.COMMON),
    /**
     * @constant
     * @type {TileType}
     */
    GRASS: new TileType('2', 'Grass', 'grass.png', true, false, TileTypeRarity.COMMON),

    /**
     * @constant
     * @type {TileType}
     */
    DIRT: new TileType('10', 'Dirt', 'dirt.png', true, true, TileTypeRarity.COMMON)
}

/**
 * @returns {TileType[]}
 */
function populateTileTypeArray() {
    // Do not add SKY, GRASS, and DIRT to the tile type array.
    const tileTypes = [];

    let id = 11;
    tileTypes.push(new TileType('' + id++, 'Blue Green Clay', 'blue_green_clay.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Red Clay', 'red_clay.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Grey Sandstone', 'grey_sandstone.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Brown Sandstone', 'brown_sandstone.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Green Pyronxenite', 'green_pyronxenite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Blue Dunite', 'blue_dunite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Deficient Hematite', 'deficient_hematite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Blue Sandstone', 'blue_sandstone.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Pink Slate', 'pink_slate.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Green Basalt', 'green_basalt.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Deep Bismuth', 'deep_bismuth.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Dark Phrenite', 'dark_phrenite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Blue Stone', 'blue_stone.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Orange Alexandrite', 'orange_alexandrite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Defective Cobalt', 'defective_cobalt.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Green Schist', 'green_schist.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Pale Blue Stone', 'pale_blue_stone.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Red Pyronxenite', 'red_pyronxenite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Teal Clay', 'teal_clay.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Bloodstone', 'bloodstone.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Grey Orange Granite', 'grey_orange_granite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Aqua Carnelion', 'aqua_carnelion.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Purple Grey Quartz', 'purple_grey_quartz.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Substandard Gypsum', 'substandard_gypsum.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Red Magnetite', 'red_magnetite.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Arkose Sandstone', 'arkose_sandstone.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Gabbro', 'gabbro.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Dark Purple Clay', 'dark_purple_clay.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Rose Stone', 'rose_stone.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Purple Grey Granite', 'purple_grey_granite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Green Slate', 'green_slate.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Blue Schist', 'blue_schist.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Rotten Vanadium', 'rotten_vanadium.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Green Quartz', 'green_quartz.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Golden Slate', 'golden_slate.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Slimy Pyrrhotite', 'slimy_pyrrhotite.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Green Jasper', 'green_jasper.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Blood Agate', 'blood_agate.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Compressed Bauxite', 'compressed_bauxite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Darkest Adventurine', 'darkest_adventurine.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Pink Amethyst', 'pink_amethyst.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Dark Iron Stone', 'dark_iron_stone.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Brown Jasper', 'brown_jasper.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Hellish Agate', 'hellish_agate.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Nasty Bauxite', 'nasty_bauxite.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Diabolical Malachite', 'diabolical_malachite.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Sun Stone', 'red_sunstone.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Cruek Cesium', 'cruel_cesium.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Orange Carnelion', 'orange_carnelion.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Purple Charoite', 'purple_charoite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Heliotrope Granite', 'heliotrope_granite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Pink Kunzite', 'pink_kunzite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Fractured Slate', 'fractured_slate.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Pink Grey Granite', 'pink_grey_granite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Blue Galaxy Granite', 'blue_galaxy_granite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Black Quartz', 'black_quartz.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Vile Hematite', 'vile_hematite.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Green Clay', 'green_clay.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Purple Granite', 'purple_granite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Blue Quartz', 'blue_quartz.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Orange Basalt', 'orange_basalt.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Yellow Sandstone', 'yellow_sandstone.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Blue Green Agate', 'blue_green_agate.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Calamitous Calcite', 'calamitous_calcite.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Brown Basalt', 'brown_basalt.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Emerald Dolomite', 'emerald_dolomite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Dark Pyroxenite', 'dark_pyroxenite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Violet Tanzanite', 'violet_tanzanite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Green Serpentine', 'green_serpentine.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Ruby Basalt', 'ruby_basalt.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Purple Schist', 'purple_schist.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Green Aragonite', 'green_aragonite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Red Spinel', 'red_spinel.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Infected Schist', 'infected_schist.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Salmon Basalt', 'salmon_basalt.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Enchanted Jasper', 'enchanted_jasper.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Cursed Basalt', 'cursed_basalt.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Sinister Slate', 'sinister_slate.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Orange Apocalypse', 'orange_apocalypse.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Devil Stone', 'devil_stone.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Asbestos', 'asbestos.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Bleak Vanadium', 'bleak_vanadium.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Poisoned Aragonite', 'poisoned_aragonite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Purple Dunite', 'purple_dunite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Corrupted Agate', 'corrupted_agate.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Torched Aragonite', 'torched_aragonite.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Forbidden Quartz', 'forbidden_quartz.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Violet Pyroxenite', 'violet_pyroxenite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Slate Soulstone', 'slate_soulstone.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Fractured Jasper', 'fractured_jasper.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Sky Quartz', 'sky_quartz.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Toxic Granite', 'toxic_granite.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Corroded Ruby', 'corroded_ruby.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Offensive Shale', 'offensive_shale.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Petrified Flamingos', 'petrified_flamingos.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Crystallized Onyx', 'crystallized_onyx.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Orange Jasper', 'orange_jasper.png', true, true, TileTypeRarity.COMMON));
    tileTypes.push(new TileType('' + id++, 'Satanic Slate', 'satanic_slate.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Malignant Pyrite', 'malignant_pyrite.png', true, true, TileTypeRarity.COMMON));

    tileTypes.push(new TileType('' + id++, 'Pink Shale', 'pink_shale.png', true, true, TileTypeRarity.COMMON));

    return tileTypes;
}

/**
 * @type {TileType[]}
 */
export const TileTypeArray = populateTileTypeArray();


const GoldTileTypes = {};
const RubyTileTypes = {};
const OreTileTypes = {};
const UpgradeTileTypes = {};

/**
 * @param {TileType} baseType 
 * @returns {TileType}
 */
export function getGold(baseType) {
    if (baseType === SpecialTileTypes.EMPTY || baseType === SpecialTileTypes.SKY) {
        return null;
    }

    let gold = GoldTileTypes[baseType.id];
    if (!gold) {
        gold = new TileType(baseType.id + '_g', 'Gold', 'gold.png', true, true, TileTypeRarity.GOLD);
        GoldTileTypes[baseType.id] = gold;
    }
    return gold;
}

/**
 * @param {TileType} baseType 
 * @returns {TileType}
 */
export function getRuby(baseType) {
    if (baseType === SpecialTileTypes.EMPTY || baseType === SpecialTileTypes.SKY) {
        return null;
    }

    let ruby = RubyTileTypes[baseType.id];
    if (!ruby) {
        ruby = new TileType(baseType.id + '_d', 'Ruby', 'ruby.png', true, true, TileTypeRarity.RUBY);
        RubyTileTypes[baseType.id] = ruby;
    }
    return ruby;
}

/**
 * @param {TileType} baseType 
 * @returns {TileType}
 */
export function getUpgrade(baseType) {
    if (baseType === SpecialTileTypes.EMPTY || baseType === SpecialTileTypes.SKY) {
        return null;
    }

    let upgrade = UpgradeTileTypes[baseType.id];
    if (!upgrade) {
        upgrade = new TileType(baseType.id + '_u', 'Upgrade', 'onyx.png', true, true, TileTypeRarity.UPGRADE);
        UpgradeTileTypes[baseType.id] = upgrade;
    }
    return upgrade;
}

/**
 * @param {TileType} baseType 
 * @returns {TileType}
 */
export function getOre(baseType) {
    if (baseType === SpecialTileTypes.EMPTY || baseType === SpecialTileTypes.SKY) {
        return null;
    }

    let upgrade = OreTileTypes[baseType.id];
    if (!upgrade) {
        upgrade = new TileType(baseType.id + '_o', 'Ore', 'purple_ore.png', true, true, TileTypeRarity.ORE);
        OreTileTypes[baseType.id] = upgrade;
    }
    return upgrade;
}

function addMapping(map, tileType) {
    map[tileType.id] = tileType;

    // If this isn't a special layer, then add gold/ore/upgrade tile types
    if (tileType === SpecialTileTypes.EMPTY || tileType === SpecialTileTypes.SKY) {
        return;
    }

    const gold = getGold(tileType);
    map[gold.id] = gold;

    const ore = getOre(tileType);
    map[ore.id] = ore;

    const upgrade = getUpgrade(tileType);
    map[upgrade.id] = upgrade;

    const ruby = getRuby(tileType);
    map[ruby.id] = ruby;
}

function buildTileTypeMap() {
    const map = {};

    addMapping(map, SpecialTileTypes.SKY);
    addMapping(map, SpecialTileTypes.GRASS);
    addMapping(map, SpecialTileTypes.DIRT);

    for (let i = 0; i < TileTypeArray.length; i++) {
        addMapping(map, TileTypeArray[i]);
    }

    return map;
}

function initializeTileColors() {
    SpecialTileTypes.SKY.openColor = '#74c2ed33';

    SpecialTileTypes.GRASS.openColor = '#709b1a33';
    SpecialTileTypes.GRASS.closedColor = '#709b1a';

    SpecialTileTypes.DIRT.openColor = '#56392733';
    SpecialTileTypes.DIRT.closedColor = '#563927';

    // 
    for (let i = 0; i < TileTypeArray.length; i++) {
        const tileType = TileTypeArray[i];
        
        tileType.openColor = '#41414133';
        tileType.closedColor = '#414141';
    }

}

initializeTileColors();

// Used by GridSave when loading grids.
export const TileTypeMap = buildTileTypeMap();
